<template>
  <div>
    <card-wrapper class="pb-4">
      <v-form @submit.prevent="download">
        <purchase-conditions-filters />
        <v-btn type="submit" block class="mt-3" color="primary" large role="download" :loading="isLoading">
          <v-icon left>mdi-file-download-outline</v-icon>
          {{ $t('page.consultation.downloadButtonText') }}
        </v-btn>
      </v-form>
    </card-wrapper>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { downloadTypedStringContent } from '@/services/download';
import { notifyError, notifyInfo } from '@/modules/notification-center';
import { getFormattedDateTimeWithoutSeparator } from '@/services/date-formater';

import PurchaseConditionsFilters from '@/components/purchase-conditions-filters.vue';
import { queryAndFormatPurchaseConditionsToCsv } from '@/modules/purchase-conditions';
import CardWrapper from '@/components/interface/card-wrapper.vue';

export default Vue.extend({
  name: 'Consultation',
  components: {
    PurchaseConditionsFilters,
    CardWrapper
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    download() {
      this.isLoading = true;
      queryAndFormatPurchaseConditionsToCsv()
        .then(csvContent => {
          if (csvContent) {
            const filename = this.$t('page.consultation.export.csvFilename', {
              date: getFormattedDateTimeWithoutSeparator(Date.now())
            }).toString();
            downloadTypedStringContent(filename, csvContent, 'text/csv');
          } else {
            const message = this.$t('notification.consultation.purchaseConditionExportEmpty');
            notifyInfo(message);
          }
        })
        .catch(() => {
          const errorMessage = this.$t('notification.consultation.purchaseConditionExportError');
          notifyError(errorMessage);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
});
</script>
